import { Center } from "@chakra-ui/react";
import { SignUp } from "@clerk/remix";
// import type { TypedResponse } from "@remix-run/node";
// import { redirect } from "@remix-run/node";

// export function loader(): TypedResponse<never> {
//   return redirect("/login", 302);
// }

// eslint-disable-next-line import/no-default-export -- Remix requires default export
export default function Signup(): JSX.Element {
  return (
    <Center h="80%">
      <SignUp
        appearance={{
          layout: {
            termsPageUrl: "/tos.html",
            privacyPageUrl: "/privacy.html",
          },

          elements: {
            card: "shadow-none",
          },
        }}
        path="/signup"
        redirectUrl="/after-login"
        routing="path"
        signInUrl="/login"
      />
    </Center>
  );
}
